let language = {
    LOGIN_INTRO_TITLE: "QP Partnership Program Registration",
    LOGIN_INTRO_1: "Create quality products easily by using {{appName}}'s high-quality printing techniques.",
    LOGIN_INTRO_2: "Empower your business's growth and achieve success in e-commerce with {{appName}}.",
    LOGIN_INTRO_3: "{{appName}}: your one-stop service for all your printing and fulfilment needs.",
};

export { language }